import React from "react";

import { useTranslation } from "react-i18next";

import { useVideoSurveyInventory } from "../../../../hooks/useVideoSurveyInventory";
import { DefaultMetrics } from "../../../../util/converts";
import { getMeasurement, getWeightMeasurement } from "../../../../util/getMeasurement";

export const InventoryInfo = () => {
  const { calculateValuesByRoom } = useVideoSurveyInventory();

  const measurement = getMeasurement();
  const measurementWeight = getWeightMeasurement();

  const { t: translate } = useTranslation();

  return (
    <>
      <span className="span-info-value">{translate("total")}</span>

      <section className="section-info">
        <div>
          <span className="span-info">{translate("qty")}</span>

          <span className="span-info-value">{`${calculateValuesByRoom().quantity || 0}`}</span>
        </div>

        <div>
          <span className="span-info">{translate("volume")}</span>

          <span className="span-info-value">{`${calculateValuesByRoom().volume || 0} ${
            measurement?.code ? measurement?.code.toUpperCase() : DefaultMetrics.VOLUME
          }`}</span>
        </div>

        <div>
          <span className="span-info">{translate("weight")}</span>

          <span className="span-info-value">{`${calculateValuesByRoom().weight || 0} ${
            measurementWeight?.code ? measurementWeight?.code.toUpperCase() : DefaultMetrics.WEIGHT
          }`}</span>
        </div>
      </section>
    </>
  );
};
